import { useEffect } from "react";

import Cookies from "js-cookie";

import Button from "@musicfy/components/Button";
import FullScreenTakeover from "@musicfy/components/FullScreenTakeover";

import FormantSlider from "./FormantSlider";
import PitchSlider from "./PitchSlider";
import { type TInferenceSettings } from "../../types";

interface IAdvancedSettingsTakeoverProps {
  isOpen: boolean;
  onClose: () => void;
  inferenceSettings: TInferenceSettings;
  setInferenceSettings: React.Dispatch<
    React.SetStateAction<TInferenceSettings>
  >;
}

const AdvancedSettingsTakeover = ({
  isOpen,
  onClose,
  inferenceSettings,
  setInferenceSettings,
}: IAdvancedSettingsTakeoverProps): JSX.Element => {
  const transpose = inferenceSettings.transpose;
  const formantFactor = inferenceSettings.formantFactor;
  const shouldIsolateVocals = inferenceSettings.shouldIsolateVocals;

  useEffect(() => {
    const _shouldIsolateVocals = Cookies.get("shouldIsolateVocals") === "true";
    setInferenceSettings((prev) => {
      return {
        ...prev,
        shouldIsolateVocals: _shouldIsolateVocals,
      };
    });
  }, [setInferenceSettings]);

  useEffect(() => {
    const _shouldIsolateVocals = Cookies.get("shouldIsolateVocals") === "true";
    if (_shouldIsolateVocals !== shouldIsolateVocals) {
      Cookies.set(
        "shouldIsolateVocals",
        shouldIsolateVocals ? "true" : "false",
        {
          expires: 365,
        }
      );
    }
  }, [shouldIsolateVocals]);

  return (
    <FullScreenTakeover
      open={isOpen}
      onClose={onClose}
      title="Advanced Settings:"
    >
      <div className="w-full mt-6">
        <div className="mx-auto w-full xl:w-[75%]">
          <div className="mt-6">
            <PitchSlider
              value={transpose}
              handleChange={(val) =>
                setInferenceSettings((prev) => {
                  return {
                    ...prev,
                    transpose: val,
                  };
                })
              }
            />
          </div>
          <div className="mt-6">
            <FormantSlider
              value={formantFactor}
              handleChange={(val) =>
                setInferenceSettings((prev) => {
                  return {
                    ...prev,
                    formantFactor: val,
                  };
                })
              }
            />
          </div>
          <Button
            aria-label="Confirm Advanced Settings"
            onClick={onClose}
            className="xl:w-1/2 w-full mx-auto mt-9"
          >
            Done
          </Button>
        </div>
      </div>
    </FullScreenTakeover>
  );
};

export default AdvancedSettingsTakeover;
